const CATEGORIES = [
  { value: 'love', label: '💕 연애/결혼' },
  { value: 'career', label: '💼 직업/커리어' },
  { value: 'relationship', label: '👥 인간관계' },
  { value: 'money', label: '💰 재물/재테크' },
  { value: 'health', label: '🌿 건강' },
  { value: 'general', label: '🔮 전체 운세' },
]

interface Props {
  selected: string
  onChange: (v: string) => void
}

export default function CategorySelector({ selected, onChange }: Props) {
  return (
    <div className="grid grid-cols-3 gap-2">
      {CATEGORIES.map((c) => (
        <button
          key={c.value}
          onClick={() => onChange(c.value)}
          className={`py-2.5 px-3 rounded-xl text-sm font-medium transition-colors border ${
            selected === c.value
              ? 'bg-[var(--color-accent)] border-[var(--color-accent)] text-[var(--color-primary)] font-bold'
              : 'bg-[var(--color-bg)] border-[var(--color-border-default)] text-[var(--color-text-tertiary)] hover:border-[var(--color-border-accent)] hover:text-[var(--color-text-primary)]'
          }`}
        >
          {c.label}
        </button>
      ))}
    </div>
  )
}
